function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "CR",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Table-View-|-Survey/year",
  transform: "translate(-1023.000000, -229.000000)",
  fill: "#9ABD69",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "sidebar",
  transform: "translate(1000.000000, 146.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "excel",
  transform: "translate(0.000000, 64.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46,33 L46,39.1666667 L50,39.1666667 L44,45 L38,39.1666667 L42,39.1666667 L42,33 L46,33 Z M36.612,23.59 L39.8329752,23.5904556 L39.8329752,25.6442114 L36.611,25.644 L36.611,26.427 L39.8329752,26.4274121 L39.8329752,28.4811679 L36.61,28.481 L36.61,29.264 L39.8329752,29.2643687 L39.8329752,31.3181244 L36.609,31.318 L36.609,32.101 L39.8329752,32.101325 L39.8329752,34.1550808 L36.608,34.155 L36.608,34.942 L39.8329752,34.9423577 L39.8329752,36.9023634 L36.607,36.902 L36.6059783,41.6100543 L23,39.1521739 L23,21.4211957 L36.6141304,19 L36.613,21.009 L46.0298913,21.2459239 C46.4640802,21.2459239 46.8225707,21.571015 46.875154,21.9909891 L46.8817935,22.0978261 L46.8817935,31.4918478 L46.0951087,31.4918478 L46.0951087,22.0244565 L36.613,22.024 L36.612,23.59 Z M32.2608696,26.2961957 L30.5815217,26.3736413 L29.375,29.2065217 L28.3722826,26.4796196 L26.6480978,26.5611413 L28.4252717,30.3029891 L26.5543478,34.0040761 L28.1480978,34.09375 L29.3138587,31.2771739 L30.5040761,34.2282609 L32.3138587,34.3342391 L30.3125,30.3029891 L32.2608696,26.2961957 Z M44.4308013,29.2643687 L44.4308013,31.3181244 L40.6152357,31.3181244 L40.6152357,29.2643687 L44.4308013,29.2643687 Z M44.4308013,26.4274121 L44.4308013,28.4811679 L40.6152357,28.4811679 L40.6152357,26.4274121 L44.4308013,26.4274121 Z M44.4308013,23.5904556 L44.4308013,25.6442114 L40.6152357,25.6442114 L40.6152357,23.5904556 L44.4308013,23.5904556 Z",
  id: "Download_Microsoft_Excel"
})))));

var SvgDownloadExcel = function SvgDownloadExcel(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadExcel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downloadExcel.ac583ff5.svg";
export { ForwardRef as ReactComponent };